var map = {
	"./3d speks.png": 5906,
	"./Angry.png": 4844,
	"./Burning Flames.png": 2192,
	"./Creepy.png": 5585,
	"./Gold Standard.png": 3194,
	"./Goofy.png": 1339,
	"./Hypnotized.png": 5875,
	"./Icy Standard.png": 7929,
	"./Laser Eyes.png": 4118,
	"./Meme Shades.png": 6166,
	"./Monacle.png": 2097,
	"./Money.png": 8682,
	"./Serious.png": 2714,
	"./Shutters.png": 9180,
	"./Standard.png": 5598,
	"./Sunglasses.png": 6638,
	"./Surprised.png": 6902,
	"./Wondering.png": 3176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2618;